(function () {
    'use strict';

    class OrderTypeMaterialCtrl {
        constructor($scope, $filter, CrudApi, $q, orderStatus) {
            let vm = this,
                promises = {},
                deregMapDataWatcher;
            vm.orderStatus = orderStatus;

            promises.articles = CrudApi.query({
                entity: 'orders',
                subentity: 'articles'
            }).$promise;

            $q.all(promises).then(({articles}) => {
                vm.articles = articles;
                $scope.$watch('edit.selectedSites', (data, oldValue) => {
                    vm.totalNetArea = 0;
                    vm.totalGrossArea = 0;
                    vm.selectedVineyards = data;
                    data.forEach(vineyard => {
                        vm.totalNetArea += vineyard.area;
                        (vineyard.plots || []).forEach((plot) => {
                            vm.totalGrossArea += plot.area;
                        });
                    });
                    if (angular.isArray($scope.edit.additionalData.articles)) {
                        $scope.edit.additionalData.articles.forEach((article) => {
                            vm.amountTotalToPerHa(article, $scope.edit.additionalData.areaMethod || 'net');
                        });
                    }

                    if (angular.isDefined(oldValue) && !angular.equals(data, oldValue)) {
                        // the vineyard list was changed so the material results might be inaccurate now
                        vm.showVineyardWarning = true;
                    }
                }, true);

                // on initial load we have to color the vineyards correctly if we are selected
                deregMapDataWatcher = $scope.$watch('edit.mapData', mapData => {
                    if (angular.isDefined(mapData)) {
                        // we only need to do this once
                        deregMapDataWatcher();
                        deregMapDataWatcher = null;
                    }
                });
            });

            vm.updateAmounts = (areaMethod) => {
                if (angular.isArray($scope.edit.additionalData.articles)) {
                    $scope.edit.additionalData.articles.forEach((article) => {
                        console.log(areaMethod);
                        vm.amountPerHaToTotal(article, areaMethod || 'net');
                    });
                }
            };

            vm.getAvailableArticles = (search, selection) => {
                let result = [];
                vm.articles.forEach((article) => {
                    let articleInList = $filter('filter')(selection, {
                        article: {
                            id: article.id
                        }
                    }, true) || [];
                    if (article.label.match(new RegExp(search), 'ig') && !articleInList.length) {
                        result.push(article);
                    }
                });
                return result;
            };

            vm.sanitizeSelection = (item, selection) => {
                let selectionItem = $filter('filter')(selection, {
                    id: item.id
                })[0];
                selection.splice(selection.indexOf(selectionItem), 1);
                selection.push({
                    article: selectionItem
                });
            };

            vm.amountPerHaToTotal = (article, areaMethod) => {
                const totalArea = areaMethod === 'gross' ? vm.totalGrossArea : vm.totalNetArea;
                article.amount = round(article.amountPerHa * totalArea, 4);
            };

            vm.amountTotalToPerHa = (article, areaMethod) => {
                const totalArea = areaMethod === 'gross' ? vm.totalGrossArea : vm.totalNetArea;
                article.amountPerHa = round(article.amount / totalArea, 4);
            };

            vm.calcAmountOfArticle = (article, site, areaMethod) => {
                let grossSize = 0;
                (site.plots || []).forEach((plot) => {
                    grossSize += plot.area;
                });
                return article.amountPerHa * (areaMethod === 'gross' ? grossSize : site.area);
            };

            function round(number, precision) {
                let factor = Math.pow(10, precision);
                return Math.round(number * factor) / factor;
            }
        }
    }

    OrderTypeMaterialCtrl.$inject = ['$scope', '$filter', 'CrudApi', '$q', 'orderStatus'];

    angular
        .module('orders.edit')
        .controller('OrderTypeMaterialCtrl', OrderTypeMaterialCtrl);
}());
